import React, {useCallback, useEffect} from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import { createApi } from '../common/API'
import { useLocation, useNavigate } from "@reach/router"

import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import useTitle from '../../hooks/title'
import classes from './Unsubscribe.module.scss'


const verifyTicket = createApi('/user/unsubscribeFromEmail', {method: 'POST', expandData: true, notify: false, noThrow: false});


const SuccessResult = observer(() => {
  return <div className={classes.result}>
    <div className={classes.resultWrapper}></div>
    <div className={classes.resultContent}>
      <div className={classes.successWrap}><CheckCircleIcon  className={classes.successIcon} /></div>
      <div className={classes.successInfo}>You've successfully unsubscribed from our emails.</div>
    </div>
  </div>
})


const ErrorResult = observer(() => {
  return <div className={classes.result}>
    <div className={classes.resultWrapper}></div>
    <div className={classes.resultContent}>
      <div className={classes.errorWrap}><ErrorIcon className={classes.errorIcon} /></div>
      <div className={classes.errorInfo}>Access ticket expried</div>
    </div>
  </div>
})


const Unsubscribe = observer(() => {
  const location = useLocation();
  const navigate = useNavigate()
  const query = new URLSearchParams(location.search)
  useTitle('Unsubscribe')

  const state = useLocalObservable(() => ({
    status: 'none', // error, success
    loading: false,
    async load() {
      const ticket = query.get('ticket')
      try {
        this.loading = true
        await verifyTicket({ticket})
        this.status = 'success'

      } catch (e) {
        console.error('Unsubscribe fail', e)
        this.status = 'error'

        setTimeout(() => {
          navigate('/', {replace: true})
        }, 3000)

      } finally {
        this.loading = false
      }
    }
  }))

  useEffect(() => {
    const ticket = query.get('ticket')
    if (!ticket) {
      navigate('/', {replace: true})
      return;
    }
    state.load()
  }, [state, navigate, query])

  let display = <div></div>;
  if (state.status == 'success') {
    display = <SuccessResult />
  }
  if (state.status == 'error') {
    display = <ErrorResult />
  }

  return <div className={classes.root}>
    <div className={classes.wrapper}></div>
    {display}
  </div>
})

export default Unsubscribe